import { JobApplication } from "../../../../Entities/JobApplication";

export type ApplicationFilterType =
  | "all"
  | "profile_qualified"
  | "profile_unqualified"
  | "profile_pending"
  | "ai_qualified"
  | "ai_unqualified"
  | "ai_pending"
  | "progressed"
  | "shortlisted"
  | "interview"
  | "hired"
  | "rejected";

export interface ApplicationCounts {
  all: number;
  profileQualified: number;
  profileUnqualified: number;
  profilePending: number;
  aiQualified: number;
  aiUnqualified: number;
  aiPending: number;
  progressed: number;
  shortlisted: number;
  interview: number;
  hired: number;
  rejected: number;
}

export interface UserApplicationsResponse {
  data: JobApplication[];
  total: number;
  currentPage: number;
  totalPages: number;
  counts: ApplicationCounts;
}

export interface FilterOption {
  key: ApplicationFilterType;
  label: string;
  countKey: keyof ApplicationCounts;
  color?: string;
  tooltip?: string;
}

// Predefined filter configurations
export const APPLICATION_FILTERS: FilterOption[] = [
  {
    key: "all",
    label: "All",
    countKey: "all",
    tooltip: "All applications for this candidate",
  },
  {
    key: "progressed",
    label: "Qualified",
    countKey: "progressed",
    color: "success",
    tooltip: "Profile Match or AI Assessment qualified",
  },
  {
    key: "shortlisted",
    label: "Shortlisted",
    countKey: "shortlisted",
    color: "processing",
    tooltip: "Marked as shortlisted by recruiter",
  },
  {
    key: "hired",
    label: "Hired",
    countKey: "hired",
    color: "success",
    tooltip: "Marked as hired",
  },
  {
    key: "rejected",
    label: "Rejected",
    countKey: "rejected",
    color: "error",
    tooltip: "Rejected applications",
  },
];













